import { Trash } from 'lucide-react';
import { toast } from 'sonner';
import { useState } from 'react';
import { UnderwearResponse } from '@repo/types/src/underwear';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useDeleteUnderwear } from '@/api/underwear/underwear.hooks';

export const DeleteUnderwear = (underwear: UnderwearResponse) => {
  const [open, setOpen] = useState(false);
  const mutation = useDeleteUnderwear();

  const handleDelete = () => {
    mutation.mutate(underwear.id, {
      onSuccess: () => {
        setOpen(false);
        toast.success(
          `La culotte ${underwear.name} a été supprimée avec succès!`,
          { duration: 3000 },
        );
      },
      onError: () => {
        toast.error(
          `Erreur lors de la suppression de la culotte ${underwear.name}`,
          { duration: 3000 },
        );
      },
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>
        <Trash color="red" size={24} />
      </DialogTrigger>
      <DialogContent>
        <DialogHeader></DialogHeader>
        <DialogTitle className="text-center">Supprimer</DialogTitle>
        <DialogDescription className="text-center">
          Êtes vous sûr de vouloir supprimer cette culotte ?
        </DialogDescription>
        <DialogFooter className="flex gap-2">
          <DialogClose asChild>
            <Button variant="ghost">Annuler</Button>
          </DialogClose>
          <Button variant="destructive" onClick={handleDelete}>
            Supprimer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
